<script lang="ts">
  import type { UserLessonStore } from 'shared/src/user/userLessons/user.lesson.store';
  import { autorun } from 'mobx';
  import { getSkillsLink } from '../skills/getSkillsLink';
  import { isLesson } from 'shared/definitions/content-definitions';
  import { onDestroy } from 'svelte';
  import Dot from '$lib/components/Dot.svelte';
  import LessonOrCheckpointDueDate from './LessonOrCheckpointDueDate.svelte';
  export let lessonStore: UserLessonStore;

  let props: {
    isComplete: boolean;
    isInProgress: boolean;
    isDueDateVisible: boolean;
    isDue: boolean;
    status: string;
    skills: string[];
    futureGradePenalty: number;
  };
  const destroyer = autorun(() => {
    let status: string = 'Ready';
    if (lessonStore.isAvailable) {
      status = 'Ready';
    } else if (lessonStore.mustCompletePriorCheckpoint) {
      status = 'Pass prior checkpoint to unlock';
    } else {
      status = 'Finish previous to unlock';
    }

    if (lessonStore.isOptional) {
      status = `Optional lesson${!lessonStore.isAvailable ? '. Finish previous.' : ''}`;
    }

    if (lessonStore.isInProgress) {
      status = 'In progress';
    }

    if (lessonStore.isComplete) {
      status = 'Done';
    }

    const definition = lessonStore.model.definition;
    const skills = isLesson(definition) ? definition.skills : undefined;
    props = {
      isComplete: lessonStore.isComplete,
      isInProgress: lessonStore.isInProgress,
      isDueDateVisible: lessonStore.isDueDateVisible,
      isDue: lessonStore.isDue,
      status,
      skills: skills!,
      futureGradePenalty: lessonStore.futureGradePenalty,
    };
  });

  onDestroy(destroyer);
</script>

<div class="text-sm">
  <p>
    <span
      class:text-green={props.isComplete}
      class:text-orange={props.isInProgress || !props.isComplete}
    >
      <Dot />
    </span>{props.status}
    {#if props.isComplete && props.skills.length}
      &ndash;
      <a class="text-blue hover:underline" href={getSkillsLink(props.skills)}> Practice </a>
    {/if}
  </p>
  <LessonOrCheckpointDueDate lessonOrCheckpointStore={lessonStore} />
  {#if !props.isComplete && props.isDueDateVisible && props.isDue}
    A {props.futureGradePenalty}% late deduction will apply.
  {/if}
</div>
